
import useCommonApi from "../../api/useCommonApi";
import { ClaveUnidadActionTypes, ClaveUnidadState, LOAD_CLAVESUNIDAD_SUCCESS } from "../types/claveUnidadActionTypes";

const apiSource = useCommonApi();

function loadClavesUnidadSuccess(clavesUnidad: ClaveUnidadState[]): ClaveUnidadActionTypes {
    return {
        type: LOAD_CLAVESUNIDAD_SUCCESS,
        clavesUnidad
    }
}

export function loadClavesUnidad(clienteId:number) {
    return function (dispatch) {
        return apiSource.obtener<ClaveUnidadState[]>("solicitud-servicio/get-catalogo-clave-unidad/"+clienteId)
            .then((clavesUnidad: ClaveUnidadState[]) => {
                dispatch(loadClavesUnidadSuccess(clavesUnidad))
            })
            .catch(error => {
                //throw error;
            })
    }
}
